export const queryKeys = {
  student: (uid: string) => ['student', uid] as const,
  assessmentConfig: () => ['assessmentConfig'] as const,
  officialExamOps: () => ['officialExamOps'] as const,
  schoolDetails: (schoolId: string) => ['schoolDetails', schoolId] as const,
  payments: (uid: string) => ['payments', uid] as const,
  studentAssessments: (uid: string) => ['studentAssessments', uid] as const,
  qod: () => ['qod'] as const,
  rewards: () => ['rewards'] as const,
  redemptions: () => ['redemptions'] as const,
  schoolAdminSummary: (schoolId: string) => ['schoolAdminSummary', schoolId] as const,
  schoolAdminRoster: (schoolId: string) => ['schoolAdminRoster', schoolId] as const,
  schoolAdminAnalyticsSummary: (schoolId: string) =>
    ['schoolAdminAnalyticsSummary', schoolId] as const,
  schoolAdminExamCompletions: (schoolId: string) =>
    ['schoolAdminExamCompletions', schoolId] as const,
  platformAdminOverview: () => ['platformAdminOverview'] as const,
  platformAdminOpenQuestionReportsCount: () =>
    ['platformAdminOpenQuestionReportsCount'] as const,
  platformAdminSchools: (filters: Record<string, string | number | undefined>) =>
    ['platformAdminSchools', filters] as const,
  platformAdminStudentStats: () => ['platformAdminStudentStats', 'others-excludes-paid'] as const,
  platformAdminStudents: (filters: Record<string, unknown>) =>
    ['platformAdminStudents', filters] as const,
  coinsLeaderboard: (uid: string) => ['coinsLeaderboard', uid] as const,
  studentSchoolLeaderboard: () => ['studentSchoolLeaderboard'] as const,
  studentReports: (uid: string) => ['studentReports', uid] as const,
};
